export interface TableColumn {
  id: string;
  header: string;
}
